import { Page, PageFace, Panel, PanelFace } from 'ui/components'

import { ReportBreadcrumbs } from '../../components'
import { Actions, ApplicationPipelineReportTable, Filter } from './components'
import { ApplicationPipelineReportContextProvider } from './context/ApplicationPipelineReportContextProvider'

const ApplicationPipelineReport = () => (
  <ApplicationPipelineReportContextProvider>
    <Page
      face={PageFace.PRIMARY}
      title={<ReportBreadcrumbs title="Application Pipeline Report" />}
      actions={<Actions />}
    >
      <Panel rounded shadowed collapsible={false} face={PanelFace.SECONDARY}>
        <Filter />
        <ApplicationPipelineReportTable />
      </Panel>
    </Page>
  </ApplicationPipelineReportContextProvider>
)

export default ApplicationPipelineReport
